export default function FlightMoreOptions(
    $compile,
    $templateRequest,
    userService,
    l10nService,
    authService
) {
    'ngInject';

    return {
        restrict: 'AE',
        scope: {
            options: '=options',
            params: '=params',
            flightsSearch: '=form',
            showOptions: '=show',
            templateUrl: '@templateUrl',
        },
        link: function(scope, element) {
            scope.availableServices = authService.getAvailableServicesFromSessionStorage();
            scope.l10n = l10nService;
            scope.isUSRegion = userService.isUSRegion();
            scope.isUKRegion = userService.isUKRegion();
            scope.isExcludeEurostarOptionVisible = userService.isUSRegion() || userService.isUKRegion();

            /**
             * "KT Charity fares only" option visible only for UK users
             * @type {boolean}
             */
            scope.isFaresOptionVisible = userService.isUKRegion();

            scope.$watch(
                'params.IncludeEuroStar', function(value) {
                    scope.dontIncludeEuroStar = !value;
                }
            );

            scope.euroStarChange = function() {
                scope.params.IncludeEuroStar = !scope.params.IncludeEuroStar;
            };

            scope.toggleShowOptions = function() {
                scope.showOptions = !scope.showOptions;
            };

            $templateRequest(scope.templateUrl).then(function(html) {
              element.html(html).show();
              $compile(element.contents())(scope);
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/directives/ktFlightMoreOptions.directive.js